import {useEffect} from "react";
import {useTypedSelector} from "../../hook/useTypedSelector";
import {useNavigate} from "react-router-dom";

const Redirect = () => {
    const {loading} = useTypedSelector((store) => store.user);
    const navigator = useNavigate();

    useEffect(() => {
        loading === false && navigator("/");
    }, [loading]);

    return (
        <div></div>
    );
}
export default Redirect;